import { PropType } from 'vue';
import { componentFactoryOf } from 'vue-tsx-support';

import { JtnUiModal } from '@jtnews/jtn-ui';
import { tsStoreMixin } from '@jtnews/shared';
import { NoServerRendering } from '@jtnews/shared/no-ssr';

// eslint-disable-next-line @typescript-eslint/naming-convention
const FeedbackToEditorsForm = () =>
  import('../../feedback-to-editors-form').then(m => m.FeedbackToEditorsForm);

const MODAL_ID = 'feedback-to-editors';
const DESKTOP_MODAL_WIDTH = 620;
const MOBILE_MODAL_WIDTH = 320;

type ModalEvents = {
  onChangeModalState: (isOpen: boolean) => void;
  onSent: () => void;
};

type ModalParams = {
  subjectPostfix?: string;
  piecePage?: string;
  dataFromRecord?: {
    contactId: string;
    recordId: string;
  };
};

export default componentFactoryOf<ModalEvents>()
  .mixin(tsStoreMixin)
  .create({
    name: 'FeedbackToEditorsModal',
    model: {
      prop: 'isOpen',
      event: 'changeModalState'
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      params: {
        type: Object as PropType<ModalParams>,
        default: {}
      }
    },
    computed: {
      maxWidth(): number {
        return this.store.deviceInfo.isMobile ? MOBILE_MODAL_WIDTH : DESKTOP_MODAL_WIDTH;
      }
    },
    methods: {
      changeModalState() {
        this.$emit('changeModalState', !this.isOpen);
      }
    },
    render() {
      return (
        <NoServerRendering>
          <JtnUiModal
            isOpen={this.isOpen}
            onToggle={() => this.changeModalState()}
            maxWidth={this.maxWidth}
            targetName={MODAL_ID}
          >
            {this.isOpen && (
              <FeedbackToEditorsForm
                props={this.params}
                onClosed={() => this.changeModalState()}
                onSent={() => this.$emit('sent')}
              />
            )}
          </JtnUiModal>
        </NoServerRendering>
      );
    }
  });
